import React, {useEffect} from "react";


const Login = ({ setErrorMessage, setFormData, formData }) => {

  useEffect(() => {
    document.title = "Welcome Back!"; // Set the title to "Login - My App"
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting form", formData); // Debug log to check the form data

    const storedUsers = Object.keys(localStorage)
      .filter((key) => key.startsWith("data")) // Get keys like "data1", "data2", etc.
      .map((key) => JSON.parse(localStorage.getItem(key)));

    const foundUser = storedUsers.find(
      (user) => user.email === formData.email && user.password === formData.password
    );

    if (foundUser) {
      alert("Login successful!");
    } else {
      setErrorMessage("Incorrect email or password.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="input-group">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
      </div>

      <div className="input-group">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          placeholder="Enter your password"
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        />
      </div>

      <button type="submit" className="auth-button">Login</button>
    </form>
  );
};

export default Login;